import { inr, num, ddmmyyyy } from "./format";

export function buildWhatsAppMessage(po, settings) {
  const v = po.vendor;
  const photos = po.items.reduce((n, it) => n + (it.photos?.length || 0), 0);
  const lines = [
    `*PURCHASE ORDER* · ${settings.company_name}`,
    `PO No: ${po.po_no}`,
    `PO Date: ${ddmmyyyy(po.po_date)}`,
    `Expected delivery: ${ddmmyyyy(po.expected_delivery) || "-"}`,
    "",
    `*Vendor*: ${v.name} (${v.code})`,
    `GSTIN: ${v.gstin || "-"}`,
    `Location: ${v.location || "-"}`,
    `Payment: ${v.payment_days} days from invoice date`,
    `Deliver to: ${po.deliver_to || "-"}`,
    "",
    "*Items*:",
    ...po.items.map((it, i) => {
      const n = it.photos?.length || 0;
      const code = it.code ? ` [${it.code}]` : "";
      const colour = it.colour ? ` (${it.colour})` : "";
      return `${i + 1}. ${it.description}${colour}${code} — ${num(it.qty)} ${it.uom} × ${inr(it.rate)} + ${it.gst}% GST = ${inr(it.total)} · ${n} photo${n === 1 ? "" : "s"}`;
    }),
    "",
    `Taxable value: ${inr(po.taxable)}`,
    `GST: ${inr(po.tax)}`,
    `*Total: ${inr(po.total)}*`,
  ];
  if (po.remarks) lines.push("", `Remarks: ${po.remarks}`);
  const terms = (settings.terms || []).filter((t) => t && t.trim());
  if (terms.length) lines.push("", "*Terms*:", ...terms.map((t, i) => `${i + 1}. ${t}`));
  lines.push("", `Item photos: ${photos} (sent below, in item order)`, `Raised by: ${po.raised_by || "-"}`);
  return lines.join("\n");
}

export const whatsappLink = (msg) => `https://wa.me/?text=${encodeURIComponent(msg)}`;

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    ta.remove();
    return ok;
  }
}
